import Link from "next/link";
import React from "react";

import Styles from "./Notification.styles";
import { NotificationProps as Props } from "./Notification.types";
import useI18n from "hooks/useI18n";

import NotificationSVG from "../../../../public/assets/images/notifications.svg";

const Notification: React.FC<Props> = props => {
  const { className, notification } = props;
  const t = useI18n();
  const { title, description, read } = notification;
  const isRead = read === "YES";

  return (
    <Styles className={`Notification ${className}`} read={isRead}>
      <div className="Notification__icon-container">
        <NotificationSVG className="Notification__icon" />
      </div>
      <h2 className="Notification__title">{title}</h2>
      <p className="Notification__description">
        {description}. {t.profile.notifications.consult}{" "}
        <Link href="/profile/orders">
          <span className="Notification__link">
            {t.profile.notifications.orders}.
          </span>
        </Link>
      </p>
    </Styles>
  );
};

Notification.defaultProps = {
  className: ""
};

export default Notification;
